<template>
  <WdsSelect
    v-if="companiesList.length > 0"
    v-model="selectedCompanies"
    can-deselect
    multi-select
    :list="companiesList"
    :label="$t('Companies')"
    :placeholder="$t('All')"
    data-test="tc-filter-companies"
    labels-primary
    @update:model-value="handleUpdate"
  />
</template>

<script setup>
import { computed, defineEmits } from 'vue'
import { WdsSelect } from '@worksome/wds-components'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  trustedContacts: {
    type: Array,
    default: [],
  },
  modelValue: {
    type: Array,
    default: [],
  },
})

const selectedCompanies = computed(() => props.modelValue)

const companiesList = computed(() => {
  const companies = new Map()
  props.trustedContacts.forEach((tc) =>
    companies.set(tc.company.id, { value: tc.company.id, label: tc.company.name }),
  )

  return [...companies.values()].filter((company) => company.value !== currentAccount.globalId)
})

// eslint-disable-next-line @typescript-eslint/no-shadow -- Baseline eslint ignore please fix if working on this
const handleUpdate = (selectedCompanies) => {
  emit('update:modelValue', selectedCompanies)
}
</script>
